import { EbookSaleAnalyticsOverview } from './EbookSaleAnalyticsOverview'
import { withEbookSaleAnalyticsOverview } from './withEbookSaleAnalyticsOverview'

const ConnectedEbookSaleAnalyticsOverview = withEbookSaleAnalyticsOverview(
  EbookSaleAnalyticsOverview
)

export { ConnectedEbookSaleAnalyticsOverview as EbookSaleAnalyticsOverview }
